module.exports = __webpack_public_path__ + "static/media/6_DSC_8116-2.cd58266e.webp";